module.exports = __webpack_public_path__ + "static/img/xcx.4ad9c69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/xcx.png
// module id = W8Kb
// module chunks = 3